import {
  DoritosIcon,
  QuakerIcon,
  RufflesIcon,
} from '../../assets/icons/sections';

type TypeSectionIcons = { [index: string]: string };

const getRandomIcon = (sections_images: TypeSectionIcons) => {
  const sections = ['quaker', 'doritos', 'ruffles'];
  const index = Math.floor(Math.random() * sections.length);
  return sections_images[sections[index]];
};

const handleSectionIcon = (section_title: string) => {
  const sectionImages: TypeSectionIcons = {
    ruffles: RufflesIcon,
    doritos: DoritosIcon,
    quaker: QuakerIcon,
  };

  if (!!section_title) {
    const sectionIcon = sectionImages[section_title.toLowerCase()];
    return sectionIcon ? sectionIcon : getRandomIcon(sectionImages);
  } else return QuakerIcon;
};

export default handleSectionIcon;
